
import {Component, Vue, Prop} from 'vue-property-decorator';
import {AIMonitorApi, classesApi} from '@/api';
import DataOverview from './components/DataOverview.vue';
import UsageStatistics from './components/UsageStatistics.vue';
import CapacityUsage from './components/CapacityUsage.vue';
import StudentUsage from './components/StudentUsage.vue';
import ExportModal from './components/ExportModal.vue';
@Component({
    components: {
        DataOverview,
        UsageStatistics,
        CapacityUsage,
        ExportModal,
        StudentUsage
    }
})
export default class AIMonitor extends Vue {
    isClass = false;
    ruleStatus = '';
    search() {
        if (this.schoolParams[1]) {
            this.isClass = true;
            this.$nextTick(() => {
                (this.$refs['studentUsage'] as StudentUsage).getData(this.ruleStatus);
            });
        } else {
            this.isClass = false;
            this.$nextTick(() => {
                (this.$refs['capacityUsage'] as CapacityUsage).getAIUsage(this.ruleList, this.ruleId);
            });
        }
        this.$nextTick(() => {
            (this.$refs['usageStatistics'] as UsageStatistics).onchangeTime({target: {value: 'month'}});
            (this.$refs['dataOverview'] as DataOverview).getData();
        });
    }
    getRuleStatus(val: string) {
        this.ruleStatus = this.ruleList.find(x => x.value === val)!.class;
    }
    showExportModal = false;
    exportData() {
        this.showExportModal = true;
    }

    schoolParams: string[] = [];
    schoolText: string[] = [];
    onChangeClass(val: string) {
        if (val) {
            this.schoolText[1] = this.classList.filter(item => item.value === val)[0].label;
        } else {
            this.schoolText.pop();
        }
    }

    ruleList: {label: string; value: string; status: string; class: string}[] = [];
    ruleId = '';
    getAIConfigBySchool(type?: string) {
        AIMonitorApi.getRulesBySchool({
            context: this,
            data: {schoolId: this.schoolParams[0]},
            success: (data: any) => {
                if (data.code === 0) {
                    this.ruleList = data.data.map((item: {name: any; _id: any; status: any}) => {
                        return {
                            label: item.name,
                            value: item._id,
                            class: item.status === '已生效' ? 'inEffect' : 'fail',
                            ...item
                        };
                    });
                    const effectItem: any = this.ruleList.filter(x => x.class === 'inEffect')[0];
                    this.ruleId = effectItem ? effectItem.value : this.ruleList[0].value;
                    this.ruleStatus = effectItem ? effectItem.class : this.ruleList[0].class;

                    if (type !== 'second') {
                        this.$nextTick(() => {
                            (this.$refs['dataOverview'] as DataOverview).getData();
                            (this.$refs['capacityUsage'] as CapacityUsage).getWarningData(this.ruleList, this.ruleId);
                            (this.$refs['usageStatistics'] as UsageStatistics).onchangeTime({target: {value: 'month'}});
                        });
                    }
                }
            }
        });
    }

    schoolName = '';
    classList: {value: string; label: string}[] = [];
    getSchoolById() {
        classesApi.getSchoolById({
            context: this,
            urlParamObj: {
                id: this.schoolParams[0]
            },
            success: (data: any) => {
                if (data.code === 0) {
                    this.schoolName = data.data.name;
                    this.schoolText[0] = this.schoolName;
                    this.getClassListBySchool();
                    this.getAIConfigBySchool();
                }
            }
        });
    }
    getClassListBySchool() {
        AIMonitorApi.getClassListBySchool({
            context: this,
            data: {schoolId: this.schoolParams[0]},
            success: (data: any, parameters: any) => {
                if (data.code === 0) {
                    if (data.data.length) {
                        this.classList = data.data.map((item: any) => {
                            return {value: item._id, label: item.name};
                        });
                    }
                    this.schoolParams[1] = '';
                }
            }
        });
    }
    created() {
        let value = window.localStorage.getItem('aicp_school_materials_$state_aicp_school_materials');
        this.schoolParams[0] = JSON.parse(value as string).schoolId;
        // this.getAreaData();
        this.getSchoolById();
    }
    mounted() {
        // this.getSchoolList();
        // this.search();
    }
}
